import React from "react";
import { useConfiguratorContext } from "../../../hooks/configurator/configurator-context";
import { OptionItem } from "./OptionItem";

interface ListDisplayProps {
  options: any[];
  section: any;
}

export const ListDisplay: React.FC<ListDisplayProps> = ({
  options,
  section,
}) => {
  const configurator = useConfiguratorContext();

  return (
    <div className="flex flex-col space-y-4">
      {options.map((option) => (
        <OptionItem
          key={option.id}
          option={option}
          section={section}
          isSelected={configurator.isOptionSelected(option.id)}
          canSelect={configurator.canSelectOption(section.id, option.id)}
          onToggle={() => configurator.toggleOption(section.id, option.id)}
        />
      ))}
    </div>
  );
};
